import { Container } from "./comonStyles";
import Rating from "@mui/material/Rating";
import { Card, CardBody, CardHeader } from "./cardStyles";
import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import leftNavArrow from "../../../../assets/icons/leftNavArrow.svg";
import rightNavArrow from "../../../../assets/icons/rightNavArrow.svg";

import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import { getAxiosClient } from "../../../../services/axios-client";
import { ApiError } from "../../../../types/api-error";

type Review = {
  author_name: string;
  author_url: string;
  language: string;
  original_language: string;
  profile_photo_url: string;
  rating: number;
  relative_time_description: string;
  text: string;
  time: number;
  translated: boolean;
};

// type Result = {
//   result: Review[] | any;
// }

// type Reviews = {
//   result: boolean;
//   error_code: ApiError;
//   payload: Result;
//   errors_debug: string[];
// }

const Opinions = () => {
  const align = { camera: "0%", panel: "0%" };

  const winWidth = window.screen.width;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const numberOfPanels = () => {
    if (winWidth < 425) {
      return 1;
    } else if (winWidth < 768) {
      return 2;
    } else if (winWidth < 1024) {
      return 3;
    } else {
      return 4;
    }
  };

  useEffect(() => {
  }, [winWidth, numberOfPanels]);

  const carouselRef = useRef<any>(null);

  const previ = useCallback(() => {
    carouselRef.current.prev().catch(() => { });
  }, []);

  const next = useCallback(() => {
    carouselRef.current.next().catch(() => { });
  }, []);

  //fetch google reviews API

  const [reviews, setReviews] = useState<Review[]>([]);

  const axiosClient = getAxiosClient();
  const fetchReviews = async () => {
    await axiosClient.ax
      .get("/GoogleApi/GetOpinions")
      .then(function (response) {
        setReviews(response.data.payload.result.reviews);
      })
      .catch(function (error) {

      });
  };

  const today: number = new Date().getTime();

  const getDate = (date: number) => {
    const diff = today - date;
    const postedDate = new Date(today - diff);
    return postedDate.toLocaleDateString("pl-PL");
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  if (reviews.length === 0) {
    return <CircularProgress color="primary" />;
  } else {
    return (
      <>
        <RatingsContainer>
          <RatingsHeader>
            Opinie naszych klientów dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of.
          </RatingsHeader>
          <RatingNav>
            {/* <Button
              variant="contained"
              style={{
                backgroundColor: theme.colors.blue01_active,
                marginRight: "10px",
              }}
            >
              Zostaw opinię
            </Button> */}
            <RatingCardsNav>
              <RatingCardsNavArrow src={leftNavArrow} onClick={previ} />
              <RatingCardsNavArrow src={rightNavArrow} onClick={next} />
            </RatingCardsNav>
          </RatingNav>
          <CardsContainer>
            <Flicking
              ref={carouselRef}
              align={align}
              duration={450}
              circular={true}
              panelsPerView={numberOfPanels()}
              // bound = {true}
              renderOnlyVisible
              moveType="snap"
              preventClickOnDrag
              // defaultIndex={1}
              noPanelStyleOverride={true}
            // autoResize = {true}
            // gap={10}
            >
              {reviews.map((review: Review, index) => (
                <CardRating key={index}>
                  {/* <CardTextContainer> */}
                  <NameAndRateWraper>
                    <CardOpinionHeader>{review.author_name}</CardOpinionHeader>
                    <Rating name="read-only" value={review.rating} readOnly />
                  </NameAndRateWraper>
                  <CardBodyRating>{review.text}</CardBodyRating>
                  <CardDate>{getDate(review.time * 1000) + " r."}</CardDate>
                  {/* </CardTextContainer> */}
                </CardRating>
              ))}
            </Flicking>
          </CardsContainer>
        </RatingsContainer>
      </>
    );
  }
};

export default Opinions;

const RatingsContainer = styled(Container)`
  flex-direction: column;
  max-width: 100%;
  @media ${theme.device.Mtablet} {
    max-width: 60%;
  }
`;

const RatingsHeader = styled.h2`
  font-size: 32px;
  margin-left: 1%;
  text-align: left;

  @media ${theme.device.Mtablet} {
    text-align: center;
    font-size: 14px;
  }
`;

const RatingNav = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 48px;
`;

// const RatingAddButton = styled.button`
//   width: 180px;
//   height: 50px;
//   color: ${theme.colors.white};
//   font-size: 16px;
//   background-color: ${theme.colors.blue01_active};
//   border: none;
//   border-radius: 8px;
//   margin-left: 1%;
//   cursor: pointer;

//   @media ${theme.device.Mtablet} {
//     margin-right: 10px;
//   }
// `;

const RatingCardsNav = styled.div`
  width: 80px;
  display: flex;
  justify-content: space-between;

  @media ${theme.device.laptop} {
    display: none;
  }
`;

const RatingCardsNavArrow = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-inline: 5px;

  @media ${theme.device.mobileL} {
    margin: 0;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const CardRating = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 60%;
  height: 265px;
  padding: 25px;
  // margin: 0;
  justify-content: space-between;

  @media ${theme.device.tablet} {
    // 768
    width: 35%;
  }

  @media ${theme.device.laptop} {
    // 1024
    width: 27%;
  }

  @media ${theme.device.laptopL} {
    // 1440
    width: 19%;
  }
`;

const CardBodyRating = styled(CardBody)`
  height: 150px;
`;

const CardDate = styled(CardBody)`
  margin-top: 2rem;
  margin-bottom: 1rem;
  height: auto;
  font-weight: 700;
`;

const CardOpinionHeader = styled(CardHeader)`
  margin-left: 4px;
  margin-bottom: 6px;
  margin-top: 0;
`;

const NameAndRateWraper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 20px;
`;
